module.exports = __webpack_public_path__ + "static/media/cl.2d1dfb37.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/images/cl.gif
// module id = 13234
// module chunks = 0